import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {userLimitKey} from 'common/types/ServiceUserLimit';
import {getServiceLimits} from 'ondemand/selectors';
import {fetchServiceLimits} from 'ondemand/actions/serviceLimits';
import EligibilityLimitsDialog from './EligibilityLimitsDialog';

const hasLimits = (service) =>
  Boolean(service && service.user_limits && service.user_limits.length);

export class EligibilityLimitsAlert extends React.Component {
  static propTypes = {
    service: PropTypes.object,
    usageByKey: PropTypes.object,
    fetchServiceLimits: PropTypes.func.isRequired,
  };

  // Open the dialog each time a service with limits becomes active; shownForServiceId stops it
  // re-opening on unrelated re-renders. (Swap this gate for sessionStorage = "once per session".)
  static getDerivedStateFromProps(props, state) {
    const serviceId = props.service ? props.service.service_id : null;
    if (serviceId === state.shownForServiceId) {
      return null;
    }
    return {open: hasLimits(props.service), shownForServiceId: serviceId};
  }

  state = {
    open: false,
    shownForServiceId: null,
  };

  componentDidMount() {
    this._fetchIfChanged(null);
  }

  componentDidUpdate(prevProps) {
    this._fetchIfChanged(prevProps.service);
  }

  // Load usage whenever a service with limits becomes active (dispatch only, no setState here).
  _fetchIfChanged(prevService) {
    const {service} = this.props;
    if (!hasLimits(service)) return;
    const prevId = prevService ? prevService.service_id : null;
    if (service.service_id !== prevId) {
      this.props.fetchServiceLimits(service.service_id);
    }
  }

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const {service, usageByKey} = this.props;
    if (!hasLimits(service)) return null;
    return (
      <EligibilityLimitsDialog
        userLimits={service.user_limits}
        usageByKey={usageByKey}
        open={this.state.open}
        handleClose={this.handleClose}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {service} = ownProps;
  const limits = service ? getServiceLimits(state, service.service_id) : null;
  const usageByKey = {};
  if (limits) {
    limits.forEach((limit) => { usageByKey[userLimitKey(limit)] = limit.current_usage; });
  }
  return {usageByKey};
};

export default connect(mapStateToProps, {fetchServiceLimits})(EligibilityLimitsAlert);



// WEBPACK FOOTER //
// ./src/ondemand/components/EligibilityLimitsAlert/EligibilityLimitsAlert.js